<template>
  <div class="row">
    <div class="col-12">
      <label for="inputSelectQueue">Filas</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="selectQueue">
            <i class="fas fa-users fa-fw"></i>
          </span>
        </div>
        <select
          class="form-control"
          id="inputSelectQueue"
          aria-label="Queue"
          aria-describedby="selectQueue"
          required
          v-model="selectedQueue"
          @change="updateTypeSelect"
          name="queue"
          ref="queue"
          style="width:150px;"
        >
          <option value="*">Todas</option>
            <option :key="queue.id" v-for="queue in userQueues" :value="queue.id">{{ queue.name }}</option>
        </select>
      </div>
      <input type="hidden" name="typeSelect" :value="typeSelect">
      <input type="hidden" name="groupName" :value="selectedGroupName">
    </div>
  </div>
</template>
<script>
import { BModal, BButton } from 'bootstrap-vue';
import axios from 'axios';
export default {
  components: {
    BModal,
    BButton
  },
  data() {
    return {
      userQueues: [], // Filas do usuário
      allQueues: [],  // Todas as filas
      groups: [],
      selectedQueue: '*',
      typeSelect: '',
      selectedGroupName: '',
      selectedGroupQueues: []
    };
  },
  created() {
    this.getUserQueues();
    this.getAllQueues(); 
  },
  methods: {
    getUserQueues() {
      axios.get("/user/listQueueUser").then(response => {
        this.userQueues = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    getAllQueues() {
      axios.get("/user/listQueue").then(response => {
        this.allQueues = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    updateTypeSelect() {
      this.$emit('selection-changed', this.selectedQueue);
    },
    clearGroupQueues() {
      this.selectedGroupQueues = [];
    }
  }
};
</script>
<style scoped>
.input-group-text {
  background-color: #007bff;
  color: #fff;
}
.b-modal {
  text-align: center;
}
.list-group-item {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
}
.b-modal-header {
  background-color: #007bff;
  color: #fff;
}
.b-modal-body {
  padding: 2rem;
}
.b-modal-footer {
  display: none;
}
</style>